export enum UnitType {
  TANK = 'tank',
  RANGED = 'ranged',
  CHARGER = 'charger'
}

export enum EnemyType {
  MELEE = 'melee',
  RANGED = 'ranged'
}

export interface UnitStats {
  health: number;
  maxHealth: number;
  damage: number;
  speed: number;
  range: number;
}

export interface GameConfig {
  unitSpawnInterval: number;
  enemySpawnInterval: number;
  baseHealth: number;
  waveDifficulty: number;
}